import styled, { css } from 'styled-components';
import { ANIMATION_DURATION, getToken } from '@optimus-web/common';
import { getSpacingToken } from '@optimus-web/core';
import { HEIGHT_APP_NAV_BAR } from '../../components';

export const AssistantContainer = styled.div<{
    isMobileOrTablet: boolean;
    mobileSearchOpened: boolean | undefined;
}>`
    width: 70%;
    height: ${HEIGHT_APP_NAV_BAR};
    padding-left: ${getSpacingToken('300')}px;
    padding-right: ${getSpacingToken('200')}px;
    display: grid;
    grid-template-rows: 1fr 0;
    transition: transform, opacity;
    transition-duration: ${ANIMATION_DURATION.default}ms;

    ${(props) =>
        props.isMobileOrTablet &&
        css`
            position: absolute;
            background: ${getToken('backgroundStaticSunken')};
            width: 100%;
            left: 0;
            z-index: 10;
            padding: 0 ${getSpacingToken('300')}px 0 0;
        `}

    ${(props) =>
        props.isMobileOrTablet &&
        props.mobileSearchOpened &&
        css`
            transform: translateY(0);
        `}

    ${(props) =>
        props.isMobileOrTablet &&
        !props.mobileSearchOpened &&
        css`
            transform: translateY(-${HEIGHT_APP_NAV_BAR});
            opacity: 0;
        `}
`;
